module.exports = __webpack_public_path__ + "static/media/web logos_ESA.cac775b4.jpg";